import type { aiConfigUsageGateTrials } from '@gonfalon/dogfood-flags/dogfood-flags';

/**
 * Determines if AI Config usage is allowed based on the usage gate trials flag.
 *
 * @param limits - The AI config usage limits from the feature flag
 * @returns true if usage is allowed (both limits are greater than or equal to 1), false otherwise
 */
export function isAiConfigUsageAllowed(limits: ReturnType<typeof aiConfigUsageGateTrials>): boolean {
  return limits.hardLimit >= 1 && limits.softLimit >= 1;
}
